module.exports = __webpack_public_path__ + "static/media/paperclip.69ae73e8.svg";